import { defineStore } from 'pinia'
import type { NewsDetails } from '~/api'

export const useNewsStore = defineStore('newsStore', () => {
  const api = useApi()

  const pageData = ref<NewsDetails | null>(null)

  const fetchArticle = async (id: string) => {
    pageData.value = (await api.public['news.detail'](id)).data
  }

  return {
    pageData,

    fetchArticle,
  }
})
